export const ENTITY_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const;

export type EntityStatus =
  (typeof ENTITY_STATUS)[keyof typeof ENTITY_STATUS];

export {
  CHANNEL_META,
  DELIVERY_CHANNEL,
  getChannelMeta,
  getDeliveryChannelLabel,
  normalizeDeliveryChannel,
} from "@src/shared/constants/delivery-channel.constants";
export type { DeliveryChannel } from "@src/shared/constants/delivery-channel.constants";

export const isActiveEntityStatus = (status?: string | null) =>
  status?.toLowerCase() === ENTITY_STATUS.ACTIVE;

export const getEntityToggleStatus = (status?: string | null) =>
  isActiveEntityStatus(status)
    ? ENTITY_STATUS.INACTIVE
    : ENTITY_STATUS.ACTIVE;

export const normalizeEntityFormStatus = (status: unknown) => {
  if (typeof status !== "string") return status;
  const normalized = status.trim().toLowerCase();
  if (normalized === ENTITY_STATUS.INACTIVE) return ENTITY_STATUS.INACTIVE;
  if (normalized === ENTITY_STATUS.ACTIVE) return ENTITY_STATUS.ACTIVE;
  return status;
};

export const PLATFORM_CONFIGURATION_PATH = "/apps/platform-configuration";

export const NOTIFICATION_TEMPLATE_LIST_PATH =
  `${PLATFORM_CONFIGURATION_PATH}/notification-templates`;

export const APP_NOTIFICATION_LIST_PATH =
  `${PLATFORM_CONFIGURATION_PATH}/app-notifications`;

export const NOTIFICATION_LOGS_LIST_PATH =
  `${PLATFORM_CONFIGURATION_PATH}/notification-logs`;
